<template>
  <el-aside width='auto' class="el_aside_vertical">

    <el-menu
            mode="vertical"
            :default-active="menu"
            :router="true"
            class="el-menu-vertical"
            :collapse="false"
            background-color="#fff"
            text-color="#545c64"
            active-text-color="#409eff"
            :unique-opened="true"
    >

      <p class="menu_title boxs">{{navName}}</p>

      <el-submenu
              v-for="item in routers"
              :key="item.id"
              :index="item.id.toString()"
              v-if="!item.hidden&&item.children&&item.children.length!==0"
      >
        <template slot="title">
          <i :class="item.icon"></i>
          <span slot="title">{{item.name}}</span>
        </template>
        <el-menu-item-group v-if="!item.hidden&&item.children">
          <el-menu-item
                  v-for="item_c in item.children"
                  :key="item_c.id"
                  :index="item_c.path"
                  v-if="!item_c.hidden"
          >
            {{item_c.name}}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

    </el-menu>

  </el-aside>

</template>

<script>

  import {mapGetters} from 'vuex'

  export default {
    name: 'theSider',
    data: function () {
      return {
        // 当前菜单的标题
        navName: '--',
        // 当前选中的二级菜单
        menu: this.$route.path ? this.$route.path : '/',
        // 当前的菜单数据
        routers: [],
        // 资源二级菜单
        resourceRouters: [
          {
            path: '/resource/productManage', // 一级路由
            name: 'productManage',
            meta: {
              icon: 'iconProductManage', // 图标
              title: '产品管理', // 路由标题
            },
            children: [
              {
                path: '/resource/productManage/productList', // 二级路由
                name: 'productList',
                meta: {
                  title: '产品管理',  // 路由标题
                  keepAlive: false
                }
              },
              // {
              //   path: '/resource/productManage/productAdd', // 二级路由
              //   name: 'productAdd',
              //   hidden: true,
              //   component: () => import('../../../views/Resource/ProductManage/ProductAdd/ProductAdd'),
              //   meta: {
              //     title: '添加产品',  // 路由标题
              //     keepAlive: false
              //   }
              // },
              // {
              //   path: '/resource/productManage/productEdit', // 二级路由
              //   name: 'productEdit',
              //   hidden: true,
              //   component: () => import('../../../views/Resource/ProductManage/ProductAdd/ProductAdd'),
              //   meta: {
              //     title: '编辑产品',  // 路由标题
              //     keepAlive: false
              //   }
              // },
            ],
          },
          {
            path: '/resource/numCardManage', // 一级路由
            name: 'numCardManage',
            meta: {
              icon: 'iconNumCardManage', // 图标
              title: '号卡管理', // 路由标题
            },
            children: [
              {
                path: '/resource/numCardManage/numPool', // 二级路由
                name: 'numPool',
                meta: {
                  title: '号码池',  // 路由标题
                  keepAlive: false
                }
              },
            ],
          },
        ],
        // 运营二级菜单
        operateRouters: [
          {
            path: '/operate/distributionManage', // 一级路由
            name: 'distributionManage',
            meta: {
              icon: 'iconDistributionManage', // 图标
              title: '分销管理', // 路由标题
            },
            children: [
              {
                path: '/operate/distributionManage/distributionManageIndex', // 二级路由
                name: 'distributionManageIndex',
                meta: {
                  title: '分销管理',  // 路由标题
                  keepAlive: false
                }
              }
            ],
          },
          {
            path: '/distribution',
            name: 'distribution',
            meta: {
              icon: 'iconDistributionList', // 图标
              title: '分销列表',
            },
            children: [
              {
                // 分销列表
                path: '/distribution/distributionListIndex',
                name: 'distributionListIndex',
                meta: {title: '分销列表', keepAlive: false}
              },
              {
                // 分销列表-话费预存分佣(运营商)
                path: '/distribution/PhoneBillPrestoreCommissionOperator',
                name: 'PhoneBillPrestoreCommissionOperator',
                hidden: true,
                meta: {title: '话费预存分佣(运营商)', keepAlive: false}
              },
              {
                // 分销列表-话费预存分佣(代理商)
                path: '/distribution/PhoneBillPrestoreCommissionAgent',
                name: 'PhoneBillPrestoreCommissionAgent',
                hidden: true,
                meta: {title: '话费预存分佣(代理商)', keepAlive: false}
              },
              {
                // 分销列表-靓号分佣(运营商)
                path: '/distribution/PhoneNumberCommissionOperator',
                name: 'PhoneNumberCommissionOperator',
                hidden: true,
                meta: {title: '靓号分佣(运营商)', keepAlive: false}
              },
              {
                // 分销列表-靓号分佣(代理商)
                path: '/distribution/PhoneNumberCommissionAgent',
                name: 'PhoneNumberCommissionAgent',
                hidden: true,
                meta: {title: '靓号分佣(代理商)', keepAlive: false}
              },
              {
                // 分销列表-话费分佣(运营商)
                path: '/distribution/PhoneFeeCommissionOperator',
                name: 'PhoneFeeCommissionOperator',
                hidden: true,
                meta: {title: '话费分佣(运营商)', keepAlive: false}
              },
              {
                // 分销列表-话费分佣(代理商)
                path: '/distribution/PhoneFeeCommissionAgent',
                name: 'PhoneFeeCommissionAgent',
                hidden: true,
                meta: {title: '话费分佣(代理商)', keepAlive: false}
              },
              {
                // 分销列表-套餐/产品分佣(运营商)
                path: '/distribution/PackageProductCommissionOperator',
                name: 'PackageProductCommissionOperator',
                hidden: true,
                meta: {title: '套餐/产品分佣(运营商)', keepAlive: false}
              },
              {
                // 分销列表-套餐/产品分佣(代理商)
                path: '/distribution/PackageProductCommissionAgent',
                name: 'PackageProductCommissionAgent',
                hidden: true,
                meta: {title: '套餐/产品分佣(代理商)', keepAlive: false}
              },
              {
                // 分销列表-激活奖励佣金(运营商)
                path: '/distribution/ActivateBonusCommissionOperator',
                name: 'ActivateBonusCommissionOperator',
                hidden: true,
                meta: {title: '激活奖励佣金(运营商)', keepAlive: false}
              },
              {
                // 分销列表-激活奖励佣金(代理商)
                path: '/distribution/ActivateBonusCommissionAgent',
                name: 'ActivateBonusCommissionAgent',
                hidden: true,
                meta: {title: '激活奖励佣金(代理商)', keepAlive: false}
              },
              {
                // 分销列表-设备补贴(运营商)
                path: '/distribution/EquipmentSubsidyOperator',
                name: 'EquipmentSubsidyOperator',
                hidden: true,
                meta: {title: '设备补贴(运营商)', keepAlive: false}
              },
              {
                // 分销列表-设备补贴(代理商)
                path: '/distribution/EquipmentSubsidyAgent',
                name: 'EquipmentSubsidyAgent',
                hidden: true,
                meta: {title: '设备补贴(代理商)', keepAlive: false}
              }
            ]
          },

          {
            path: '/operate/splitBillManage', // 一级路由
            name: 'splitBillManage',
            meta: {
              icon: 'iconSplitBillManage', // 图标
              title: '分账管理', // 路由标题
            },
            children: [
              {
                path: '/operate/splitBillManage/phoneFee', // 二级路由
                name: 'phoneFee',
                meta: {
                  title: '话费账单',  // 路由标题
                  keepAlive: false
                }
              },
            ],
          },
        ],
        // 财务二级菜单
        financeRouters: [
          {
            path: '/accountManage', // 一级路由
            name: 'accountManage',
            meta: {
              icon: 'iconAccountManage', // 图标
              title: '账户管理', // 路由标题
            },
            children: [
              {
                path: '/accountManage/accountManageIndex', // 二级路由
                name: 'accountManageIndex',
                meta: {
                  title: '账户管理',  // 路由标题
                  keepAlive: false
                }
              },
              {
                path: '/accountManage/manageAccount', // 二级路由
                name: 'manageAccount',
                hidden: true,
                meta: {
                  title: '管理账户',  // 路由标题
                  keepAlive: false
                }
              }
            ],
          },
          {
            path: '/financialAudit', // 一级路由
            name: 'financialAudit',
            meta: {
              icon: 'iconFinancialAudit', // 图标
              title: '财务审核', // 路由标题
            },
            children: [
              {
                path: '/financialAudit/cashOutAuditIndex', // 二级路由
                name: 'cashOutAuditIndex',
                meta: {
                  title: '提现审核',  // 路由标题
                  keepAlive: false
                }
              },
              {
                path: '/financialAudit/historyAudit', // 二级路由
                name: 'historyAudit',
                hidden: true,
                meta: {
                  title: '历史审核',  // 路由标题
                  keepAlive: false
                }
              },
              {
                path: '/financialAudit/temporaryPassword', // 二级路由
                name: 'temporaryPassword',
                hidden: true,
                meta: {
                  title: '临时密码',  // 路由标题
                  keepAlive: false
                }
              }
            ],
          },
        ],
        // 系统二级菜单
        systemRouters: [
          {
            path: '/system/auth', // 一级路由
            meta: {
              icon: 'iconPersonnelManage', // 图标
              title: '授权管理', // 路由标题
            },
            children: [
              {
                path: '/system/auth/menu', // 二级路由
                name: 'menuManage',
                meta: {
                  title: '菜单管理',  // 路由标题
                  keepAlive: false
                }
              },
              {
                path: '/system/auth/role', // 二级路由
                name: 'authRole',
                meta: {
                  title: '角色管理',  // 路由标题
                  keepAlive: false
                }
              }
            ]
          },
          {
            path: '/system/personnelManage', // 一级路由
            name: 'personnelManage',
            meta: {
              icon: 'iconPersonnelManage', // 图标
              title: '人员管理', // 路由标题
            },
            children: [
              {
                path: '/system/personnelManage', // 二级路由
                name: 'personnelManage',
                meta: {
                  title: '人员管理',  // 路由标题
                  keepAlive: false
                }
              }
            ]
          },
          {
            path: '/system/memberManage', // 一级路由
            name: 'memberManage',
            meta: {
              icon: 'iconMemberManage', // 图标
              title: '会员管理', // 路由标题
            },
            children: [
              {
                path: '/system/memberManage', // 二级路由
                name: 'memberManage',
                meta: {
                  title: '会员管理',  // 路由标题
                  keepAlive: false
                }
              },
              {
                path: '/system/memberManage/workNumConfig', // 二级路由
                name: 'workNumConfig',
                hidden: true,
                meta: {
                  title: '工号配置',  // 路由标题
                  keepAlive: false
                }
              }
            ]
          }
        ],

      }
    },
    components: {},
    computed: {
      // ...mapGetters([
      //   'permission_routers'
      // ])
    },
    watch: {
      '$route'(to, from) {
        this.menu = to.path // data中放置一个default-active的绑定数据
        // this.activeIndex = to.path // data中放置一个default-active的绑定数据

        // 用于解决二级菜单导航组件重复点击当前选中菜单报错 NavigationDuplicated
        if (to.path == from.path) {
          router.push('/location').catch(err => {
            err
          })
        }

      }
    },
    created() {
      // 先写死第一次进入页面是运营菜单
      // this.navName = '运营';
      // this.routers = this.operateRouters;
      // this.goRouterFirstPath(this.routers);
    },
    methods: {
      // 切换左侧二级菜单
      changeMenu(navItem) {
        this.navName = navItem.name;
        this.routers = navItem.children;
        this.goRouterFirstPath(this.routers);
      },
      // 切换菜单数据时，页面跳转到菜单数组中第一个菜单
      goRouterFirstPath(currentRouters) {
        if (currentRouters.length > 0) {
          let firstPath = currentRouters[0].children[0].path;
          this.$router.push(firstPath);
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .el_aside_vertical {
    // min-height: 100%;
    // background: #262626;
    z-index: 2;
  }

  // 左侧菜单栏
  .el-menu-vertical {
    min-height: 100%;
    background: #262626 !important;
  }

  .el-menu-vertical:not(.el-menu--collapse) {
    width: 180px;
  }

  // 菜单顶部标题
  .menu_title {
    width: 100%;
    height: 34px;
    line-height: 34px;
    padding-left: 14px;
    color: #B7B2AF;
    font-size: 13px;
    font-weight: bold;

  }

  li.el-submenu.is-opened .el-submenu__title {
    // color: #FFFFFF !important;
    // background-color: #FA6241 !important;
  }

  .el-submenu .el-submenu__title {
    color: #FFFFFF !important;
    background-color: #FA6241 !important;
  }

  .el-menu {
    .el-icon-menu {
      color: #545c64;
    }

    a {
      text-decoration: none;
    }

    // 二级菜单
    li.is-active {
      color: #FA6241 !important;
    }
  }

  /* 自定义-左侧菜单-二级菜单(开始) */
  .el-menu-item {
    height: 38px !important;
    line-height: 38px !important;
    font-size: 12px !important;
    color: #C5C5C5 !important;
    background-color: #1D1D1D !important;
    border-bottom: 1px solid #000000;
    padding-left: 46px !important;
  }

  .el-menu-item:hover {
    color: #f7f7f7 !important;
  }

  .el-menu-item::after {
    content: '';
    position: absolute;
    top: 11px;
    right: 12px;
    width: 16px;
    height: 16px;
    background: url('../../../assets/images/layout/sider/ri_arrow.png') no-repeat;
    background-size: 100% 100%;
  }

  /* 自定义-左侧菜单-二级菜单(结束) */


  // 图标-大小
  li.el-submenu i {
    width: 20px;
    height: 20px;
    display: inline-block;
  }


  // 图标-iconProductManage(产品管理)
  li.el-submenu i.iconProductManage {
    background: url('../../../assets/images/layout/sider/productManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconProductManage,
  li.el-submenu.is-opened i.iconProductManage {
    background: url('../../../assets/images/layout/sider/productManage2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconAccountManage(设备管理)
  li.el-submenu i.iconDeviceManage {
    background: url('../../../assets/images/layout/sider/deviceManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconDeviceManage,
  li.el-submenu.is-opened i.iconDeviceManage {
    background: url('../../../assets/images/layout/sider/deviceManage2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconNumCardManage(号卡管理)
  li.el-submenu i.iconNumCardManage {
    background: url('../../../assets/images/layout/sider/numCardManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconNumCardManage,
  li.el-submenu.is-opened i.iconNumCardManage {
    background: url('../../../assets/images/layout/sider/numCardManage2.png') no-repeat;
    background-size: 100% 100%;
  }


  // 图标-iconDistributionList(分销列表)
  li.el-submenu i.iconDistributionList {
    background: url('../../../assets/images/layout/sider/distributionList.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconDistributionList,
  li.el-submenu.is-opened i.iconDistributionList {
    background: url('../../../assets/images/layout/sider/distributionList2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconDistributionManage(分销列表)
  li.el-submenu i.iconDistributionManage {
    background: url('../../../assets/images/layout/sider/distributionManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconDistributionManage,
  li.el-submenu.is-opened i.iconDistributionManage {
    background: url('../../../assets/images/layout/sider/distributionManage2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconSplitBillManage(分账管理)
  li.el-submenu i.iconSplitBillManage {
    background: url('../../../assets/images/layout/sider/splitBillManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconSplitBillManage,
  li.el-submenu.is-opened i.iconSplitBillManage {
    background: url('../../../assets/images/layout/sider/splitBillManage2.png') no-repeat;
    background-size: 100% 100%;
  }


  // 图标-iconAccountManage(账户管理)
  li.el-submenu i.iconAccountManage {
    background: url('../../../assets/images/layout/sider/accountManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconAccountManage,
  li.el-submenu.is-opened i.iconAccountManage {
    background: url('../../../assets/images/layout/sider/accountManage2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconFinancialAudit(财务审核)
  li.el-submenu i.iconFinancialAudit {
    background: url('../../../assets/images/layout/sider/financialAudit.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconFinancialAudit,
  li.el-submenu.is-opened i.iconFinancialAudit {
    background: url('../../../assets/images/layout/sider/financialAudit2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconBillDetail(财务-账单明细)
  li.el-submenu i.iconBillDetail {
    background: url('../../../assets/images/layout/sider/billDetail.png') no-repeat;
    background-size: 100% 100%;
  }
  li.el-submenu:hover i.iconBillDetail,
  li.el-submenu.is-opened i.iconBillDetail {
    background: url('../../../assets/images/layout/sider/billDetail2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconBillDetail(财务-资金管理)
  li.el-submenu i.iconFundManage {
    background: url('../../../assets/images/layout/sider/fundManage.png') no-repeat;
    background-size: 100% 100%;
  }
  li.el-submenu:hover i.iconFundManage,
  li.el-submenu.is-opened i.iconFundManage {
    background: url('../../../assets/images/layout/sider/fundManage2.png') no-repeat;
    background-size: 100% 100%;
  }




  // 图标-iconAuthManage(授权管理)
  li.el-submenu i.iconAuthManage {
    background: url('../../../assets/images/layout/sider/authManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconAuthManage,
  li.el-submenu.is-opened i.iconAuthManage {
    background: url('../../../assets/images/layout/sider/authManage.png') no-repeat;
    // background: url('../../../assets/images/layout/sider/authManage2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconPersonnelManage(人员管理)
  li.el-submenu i.iconPersonnelManage {
    background: url('../../../assets/images/layout/sider/personnelManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconPersonnelManage,
  li.el-submenu.is-opened i.iconPersonnelManage {
    background: url('../../../assets/images/layout/sider/personnelManage2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconRoleManage(角色管理)
  li.el-submenu i.iconRoleManage {
    background: url('../../../assets/images/layout/sider/roleManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconRoleManage,
  li.el-submenu.is-opened i.iconRoleManage {
    background: url('../../../assets/images/layout/sider/roleManage2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconMemberManage(会员管理)
  li.el-submenu i.iconMemberManage {
    background: url('../../../assets/images/layout/sider/memberManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconMemberManage,
  li.el-submenu.is-opened i.iconMemberManage {
    background: url('../../../assets/images/layout/sider/memberManage2.png') no-repeat;
    background-size: 100% 100%;
  }



  // 图标-iconNumCardOrder(号卡订单)
  li.el-submenu i.iconNumCardOrder {
    background: url('../../../assets/images/layout/sider/numCardOrder.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconNumCardOrder,
  li.el-submenu.is-opened i.iconNumCardOrder {
    background: url('../../../assets/images/layout/sider/numCardOrder2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconRechargeAndPaymentOrder(充值/缴费订单)
  li.el-submenu i.iconRechargeAndPaymentOrder {
    background: url('../../../assets/images/layout/sider/rechargeAndPaymentOrder.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconRechargeAndPaymentOrder,
  li.el-submenu.is-opened i.iconRechargeAndPaymentOrder {
    background: url('../../../assets/images/layout/sider/rechargeAndPaymentOrder2.png') no-repeat;
    background-size: 100% 100%;
  }




  // 图标-iconMallIndex(商城首页)
  li.el-submenu i.iconMallIndex {
    background: url('../../../assets/images/layout/sider/mallIndex.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconMallIndex,
  li.el-submenu.is-opened i.iconMallIndex {
    background: url('../../../assets/images/layout/sider/mallIndex2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconOrderManage(订单管理)
  li.el-submenu i.iconGoodsList {
    background: url('../../../assets/images/layout/sider/orderManage.png') no-repeat;
    background-size: 100% 100%;
  }
  li.el-submenu i.iconOrderManage {
    background: url('../../../assets/images/layout/sider/orderManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconOrderManage,
  li.el-submenu.is-opened i.iconOrderManage {
    background: url('../../../assets/images/layout/sider/orderManage2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconGoodsManage(商品管理)
  li.el-submenu i.iconGoodsManage {
    background: url('../../../assets/images/layout/sider/goodsManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconGoodsManage,
  li.el-submenu.is-opened i.iconGoodsManage {
    background: url('../../../assets/images/layout/sider/goodsManage2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconAfterSaleManage(售后管理)
  li.el-submenu i.iconAfterSaleManage {
    background: url('../../../assets/images/layout/sider/afterSaleManage.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconAfterSaleManage,
  li.el-submenu.is-opened i.iconAfterSaleManage {
    background: url('../../../assets/images/layout/sider/afterSaleManage2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconMallConfig(商城配置)
  li.el-submenu i.iconMallConfig {
    background: url('../../../assets/images/layout/sider/mallConfig.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconMallConfig,
  li.el-submenu.is-opened i.iconMallConfig {
    background: url('../../../assets/images/layout/sider/mallConfig2.png') no-repeat;
    background-size: 100% 100%;
  }

  


  // 图标-iconOperationalData(运营数据)
  li.el-submenu i.iconOperationalData {
    background: url('../../../assets/images/layout/sider/operationalData.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconOperationalData,
  li.el-submenu.is-opened i.iconOperationalData {
    background: url('../../../assets/images/layout/sider/operationalData2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-iconBusiUnsubscribe(业务退订)
  li.el-submenu i.iconBusiUnsubscribe {
    background: url('../../../assets/images/layout/sider/busiUnsubscribe.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.iconBusiUnsubscribe,
  li.el-submenu.is-opened i.iconBusiUnsubscribe {
    background: url('../../../assets/images/layout/sider/busiUnsubscribe2.png') no-repeat;
    background-size: 100% 100%;
  }




  // 图标-icon1(测试)
  li.el-submenu i.icon1 {
    background: url('../../../assets/images/layout/sider/套餐管理.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.icon1,
  li.el-submenu.is-opened i.icon1 {
    background: url('../../../assets/images/layout/sider/套餐管理2.png') no-repeat;
    background-size: 100% 100%;
  }

  // 图标-icon2(测试)
  li.el-submenu i.icon2 {
    background: url('../../../assets/images/layout/sider/活动管理.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu:hover i.icon2,
  li.el-submenu.is-opened i.icon2 {
    background: url('../../../assets/images/layout/sider/活动管理2.png') no-repeat;
    background-size: 100% 100%;
  }

  li.el-submenu i.websiteAndMerchants {
      background: url('../../../assets/images/recordInformatica/recordInformatica.png') no-repeat;
      background-size: 100% 100%;
  }
  li.el-submenu i.businessUnsubscribe {
      background: url('../../../assets/images/businessUnsubscribe/businessUnsubscribe.png') no-repeat;
      background-size: 100% 100%;
  }

</style>
